/* eslint-disable max-len */
import React from 'react';

interface Props extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const Paragraph: React.FC<Props> = ({ ...props }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.249878 4.99991C0.249878 4.58569 0.585664 4.24991 0.999878 4.24991H10.9999C11.4141 4.24991 11.7499 4.58569 11.7499 4.99991C11.7499 5.41412 11.4141 5.74991 10.9999 5.74991H0.999878C0.585664 5.74991 0.249878 5.41412 0.249878 4.99991ZM14.4999 4.24991C14.795 4.24991 15.0627 4.423 15.1838 4.69213L19.6838 14.6921C19.8538 15.0699 19.6854 15.5139 19.3077 15.6838C18.9299 15.8538 18.4859 15.6854 18.3159 15.3077L16.8786 12.1135H12.1212L10.6838 15.3077C10.5138 15.6854 10.0698 15.8538 9.6921 15.6838C9.31437 15.5139 9.14596 15.0699 9.31594 14.6921L13.8159 4.69213C13.937 4.423 14.2047 4.24991 14.4999 4.24991ZM12.7962 10.6135H16.2036L14.4999 6.82755L12.7962 10.6135ZM0.249878 9.99991C0.249878 9.58569 0.585664 9.24991 0.999878 9.24991H7.99988C8.41409 9.24991 8.74988 9.58569 8.74988 9.99991C8.74988 10.4141 8.41409 10.7499 7.99988 10.7499H0.999878C0.585664 10.7499 0.249878 10.4141 0.249878 9.99991ZM0.249878 14.9999C0.249878 14.5857 0.585664 14.2499 0.999878 14.2499H5.99988C6.41409 14.2499 6.74988 14.5857 6.74988 14.9999C6.74988 15.4141 6.41409 15.7499 5.99988 15.7499H0.999878C0.585664 15.7499 0.249878 15.4141 0.249878 14.9999Z"
      fill={props.color ?? props?.style?.color}
    />
  </svg>
);

export default Paragraph;
